import {
  Card,
  CardActionArea,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import type { ReactNode } from "react";

type ChatModeButtonProps = {
  icon: ReactNode;
  title: string;
  subtitle: string;
  onClick: () => void;
  testId?: string;
  /** Theme color path for the icon (e.g. "primary.main"). Defaults to "primary.main". */
  iconColor?: string;
};

const ChatModeButton = ({
  icon,
  title,
  subtitle,
  onClick,
  testId,
  iconColor = "primary.main",
}: ChatModeButtonProps) => {
  return (
    <Card
      variant="outlined"
      sx={{
        height: "100%",
        transition: "border-color 0.2s, transform 0.2s",
        "&:hover": {
          borderColor: iconColor,
          transform: "translateY(-4px)",
        },
      }}
    >
      <CardActionArea
        onClick={onClick}
        data-testid={testId}
        sx={{ height: "100%", minHeight: 168 }}
      >
        <CardContent
          sx={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Stack spacing={1} alignItems="center" textAlign="center">
            <Stack sx={{ color: iconColor }}>{icon}</Stack>
            <Typography variant="h6" fontWeight={600}>
              {title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default ChatModeButton;
